<template>
<div class="panel">
    <teamStatusModal v-if="showTeamModal" :league=chosenSeason.id @closeMessage="showTeamModal = false"></teamStatusModal>
    <div class="row columns">
        <div class="panel-title big-title">
            Rapport de match
        </div>
        <wizard :step="0"></wizard>
        <hr>
        <div class="panel-content">
            <br>
            <div class="row columns">
                <div class="large-5 large-centered columns ">
                    <div class="team-title" v-if="$store.getters.formatedClubList">Club</div>
                        <select v-model="chosenClub">
                            <option v-for="club in $store.getters.formatedClubList" v-bind:value="club">
                                    {{ club.name }}
                            </option>
                        </select>
                        <template v-if="selectedClub">
                            <div  class="team-title">Competition</div>
                                <select v-model="chosenLeague" v-if="chosenClub !== null"
                                    :disabled="chosenClub === null">
                                    <option v-for="league in chosenClub.leagues" v-bind:value="league">
                                    {{league.name}}
                                    </option>
                                </select>
                            <div  class="team-title">Saison</div>
                                <select v-model="chosenSeason" v-if="chosenLeague"
                                    :disabled="chosenLeague === undefined">
                                    <option v-for="rg in chosenLeague.seasons" v-bind:value="rg">
                                    {{rg.name}}
                                    </option>
                                </select>
                        </template>
                </div>
            </div>
            <div v-if="selectedClub && selectedClub.name === 'Valdemor BBC'" class="row columns">
                <div class="large-5 large-centered columns ">
                    <div class="team-title">type de match</div>
                    <select v-model="matchType">
                        <option v-bind:value="false">
                        Match régulier
                        </option>
                        <option v-bind:value="true">
                        Dungeon Bowl
                        </option>
                    </select>
                </div>
            </div>
            <br>
            <div class="row columns" v-if="!matchType">
                <div class="large-5 columns ">
                    <div class="team-title">Equipe domicile</div>
                  <multiselect
                    v-model="teams[0]"
                    id="0"
                    :options="homeAvailableTeam"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :preserve-search="true"
                    placeholder="Equipe domicile"
                    :show-labels="false"
                    label="name"
                    track-by="team.name"
                    :custom-label="teamLabel"
                    :preselect-first="false"
                    class="team-select"
                  >
                  </multiselect>
                    <img v-if="teams[0]" class="team-icon-big" v-bind:src="getRosterIcon(teams[0])" alt="">
                    <div v-else>
                        <div class="row columns">
                            <button v-if="chosenLeague" @click="showTeamModal = true" class="light-grey-button">Mon équipe n'est pas dans la liste !</button>
                        </div>
                    </div>
                </div>
                <div class="large-2 columns text-centered">
                    <div>Vs</div>
                </div>
                <div class="large-5 columns right">
                    <div class="team-title">Equipe Visiteur</div>
                  <multiselect
                    v-model="teams[1]"
                    :options="visitorsAvailableTeam"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :preserve-search="true"
                    placeholder="Equipe Visiteur"
                    :show-labels="false"
                    label="name"
                    track-by="team.name"
                    :custom-label="teamLabel"
                    class="team-select"
                    :preselect-first="false">
                  </multiselect>
                    <img v-if="teams[1] !== null" class="team-icon-big" v-bind:src="getRosterIcon(teams[1])" alt="">
                    <div v-else>
                        <div class="row columns">
                            <button v-if="chosenLeague" @click="showTeamModal = true" class="light-grey-button">Mon équipe n'est pas dans la liste !</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else >
                <div class="row columns">
                    <button v-if="chosenLeague"
                        @click="showTeamModal = true"
                        class="light-grey-button">Mon équipe n'est pas dans la liste !
                    </button>
                </div>
                <br>
                <div v-for="team, index of teams" class="row columns">
                    <div class="large-2 columns">
                        <div class="team-title">
                            Equipe n° {{index + 1}}</div>
                    </div>
                    <div class="large-5 columns ">
                        <select :disabled="!chosenLeague" v-model="teams[index]">
                            <option v-for="team of leagueTeam" v-bind:value="team">
                            {{team.name}}
                            </option>
                        </select>
                    </div>
                    <div class="large-3 columns">
                        <img v-if="team.id != 0" class="team-icon-big" v-bind:src="getRosterIcon(team)" alt="">
                        <div v-else>
                        </div>
                    </div>
                    <div class="large-2 columns ">
                        <div>
                            <div class="row columns">
                                <button class="alert" :id="team.id" @click="removeTeam($event)">supprimer</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row columns">
                    <div class="large-4 large-centered columns">
                        <button @click="addTeam" class="full-width" >Ajouter une équipe</button>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <div class="row columns">
                <div class="large-2 large-centered columns">
                    <button @click="validate" class="full-width" :disabled="teams[1] === null || teams[0] === null || teams[0].id === teams[1].id" >Suivant</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import wizard from '../common/wizard.vue'
import confirmModal from '../common/confirm-modal.vue'
import messageModal from '../common/message-modal.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import matchReport from '../../api/match-report.api'
import teamStatusModal from '../common/team-status-modal.vue'
import Vue from 'vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'mrStep1',
  components: {
    spinner,
    confirmModal,
    messageModal,
    teamStatusModal,
    wizard,
    Multiselect
  },
  props: {
    'id': null
  },
  data () {
    return {
      teams: [null, null],
      isInit: false,
      showTeamModal: false,
      matchType: false,
      selectedClub: null,
      selectedLeague: null,
      selectedSeason: null,
      selectedHomeTeam: null,
      selectedVisitorTeam: null
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'teamList',
      'matchReportList',
      'clubList'
    ]),
    chosenClub: {
      get: function () {
        return this.selectedClub
      },
      set: function (newSelectedClub) {
        this.selectedClub = newSelectedClub
        this.chosenLeague = newSelectedClub.leagues[newSelectedClub.leagues.length - 1]
      }
    },
    chosenLeague: {
      get: function () {
        return this.selectedLeague
      },
      set: function (newChosenLeague) {
        this.selectedLeague = newChosenLeague
        this.chosenSeason = newChosenLeague.seasons[newChosenLeague.seasons.length - 1]
      }
    },
    chosenSeason: {
      get: function () {
        return this.selectedSeason
      },
      set: function (newChosenSeason) {
        this.selectedSeason = newChosenSeason
        console.log(newChosenSeason)
        this.$store.dispatch('refreshTeamListForLeague', newChosenSeason.id)
      }
    },
    publishedTeamList: function () {
      if (this.teamList) {
        return this.teamList.filter(team => { return team.status === 1 })
      }
      return null
    },
    leagueTeam: function () {
      if (!this.chosenLeague || !this.publishedTeamList) {
        return null
      }
      return this.publishedTeamList.filter(team => { return team.league.id === this.chosenSeason.id })
    },
    ownTeams: function () {
      if (!this.chosenLeague) {
        return null
      }
      return this.leagueTeam.filter(team => { return team.user === this.currentUser.username })
    },
    foeTeams: function () {
      if (!this.chosenLeague) {
        return null
      }
      return this.leagueTeam.filter(team => { return team.user !== this.currentUser.username })
    },
    // renvoi une liste d'équipe élligible, cad qui n'est pas présent dans un rapport non finit
    homeAvailableTeam: function () {
      if (!this.currentUser || !this.leagueTeam) {
        return []
      }
      let availableTeam = []
      let baseTeams = []
      // si l'utilisateur est un quidam, il faudrait piocher uniquement dans ses propres teams
      // si c'est un admin, on prend toutes les teams
      if (this.currentUser.is_superuser) {
        baseTeams = this.leagueTeam
      } else {
        baseTeams = this.ownTeams
      }
      // pour toutes les équipes de base, on les vire si on trouve un rapport de match en cours qui les concerne
      baseTeams.forEach(t => {
        let startedReports = this.matchReportList.filter(mr => { return mr.status === 0 })
        let foundreport = startedReports.find(mr => { return mr.home_report.team.id === t.id || mr.visitor_report.team.id === t.id })
        if (!foundreport) {
          availableTeam.push(t)
        }
      })
      return availableTeam
    },
    visitorsAvailableTeam: function () {
      // renvoi une liste d'équipe élligible, cad qui n'est pas présent dans un rapport non finit,
      // et qui n'est pas présent dans le tableau des équipes choisis
      let availableTeam = []
      let baseTeams = []
      if (!this.currentUser || !this.leagueTeam || this.teams[0] === null) {
        return []
      }
      if (this.currentUser.is_superuser) {
        baseTeams = this.leagueTeam.filter(team => { return team.id !== this.teams[0].id })
      } else {
        baseTeams = this.foeTeams
      }
      baseTeams.forEach(t => {
        let startedReports = this.matchReportList.filter(mr => { return mr.status === 0 })
        let foundreport = startedReports.find(mr => { return mr.home_report.team.id === t.id || mr.visitor_report.team.id === t.id })
        if (!foundreport) {
          availableTeam.push(t)
        }
      })
      return availableTeam
    },
    customLabel ({ title, desc }) {
      return `${title} – ${desc}`
    }
  },
  methods: {
    updateVisitors (params) {
      this.teams[1] = params
    },
    updateHome (params, id) {
      this.teams[0] = params
    },
    teamLabel ({name, user}) {
      return `${name} — ${user}`
    },
    addTeam () {
      let team = {}
      team.user = ''
      team.name = ''
      team.id = 0
      if (!this.teams) {
        Vue.set(this.teams, 0, team)
      } else {
        Vue.set(this.teams, this.teams.length, team)
      }
    },
    removeTeam ($event) {
      if (!$event.currentTarget.id) {
        return
      }

      let index = this.teams.findIndex(team => team.id === parseInt($event.currentTarget.id, 10))
      this.teams.splice(index, 1)
    },
    validate () {
      // si l'id est setté, le rapport doit être mis à jour et crée sinon
      this.createMatchReport()
    },
    createMatchReport () {
      let mr = {}
      mr.team_reports = []
      mr.status = 0
      mr.is_db_report = this.matchType
      // on filtre les lignes vides
      let filteredTeams = this.teams.filter(team => { return team.id !== 0 })
      // si le match n'est pas un DB, on vire les équipes supplémentaires
      if (this.matchType && filteredTeams.length > 2) {
        this.teams.splice(2, filteredTeams.length - 2)
      }
      filteredTeams.forEach(team => {
        let tr = {}
        tr.team = team.id
        mr.team_reports.push(tr)
      })

      // on crée le rapport de match
      matchReport.api.createMatchReport(mr)
      .then(response => {
        console.log(response)
        console.log(this)
        this.$store.dispatch('invalidateDetailedMatchReport')
        if (this.matchType === false) {
          console.log(response)
          this.$router.push({name: 'mrStep2', params: { id: response.data['id'] }})
        } else {
          this.$router.push({name: 'mrDBStep2', params: { id: response.data['id'] }})
        }
      }, error => {
        console.log('impossible to create match report')
        console.log(error)
      })
    },
    getRosterIcon (team) {
      if (team === null) {
        return ''
      }
      return '/static/imgs/team-icons/' + team.ref_roster.replace(/\s+/, '') + '.png'
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.team-select {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// mr-step-1.vue?d230a096